export default __webpack_public_path__ + "static/palette-saturated-mapping-9bbe0238bf2799c61d9fd20c7a1b2267182839284272740fd4ff9231a470704d.png";